import * as React from 'react'
import { ReactNode } from 'react'
import { useQueryMaintenanceMode } from '@/modules/shared/query-client/useQueryMaintenanceMode'
import { useUser } from '@/modules/shared/context/UserContext'
import { MaintenanceOverlay } from './MaintenanceOverlay'
import { MaintenanceBanner } from './MaintenanceBanner'

interface Props {
  children: ReactNode
}

export const MaintenanceGuard: React.FC<Props> = ({ children }) => {
  const { data } = useQueryMaintenanceMode()
  const { isAdmin } = useUser()

  if (data?.isActive) {
    if (isAdmin()) {
      return (
        <>
          <MaintenanceBanner />
          {children}
        </>
      )
    }
    return <MaintenanceOverlay message={data.message} />
  }

  return <>{children}</>
}
